import { Layout } from "@/components/Layout";
import { SeoHead } from "@/components/SeoHead";
import { CheckCircle, Phone, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PHONE_HREF, PHONE_NUMBER } from "@/components/EmergencyBanner";
import { Link } from "react-router-dom";
import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

const ThankYou = () => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      form_name: "service_request",
      page_path: "/thank-you",
    });
    window.dataLayer.push({
      event: "conversion",
      conversion_type: "form_submission",
      page_path: "/thank-you",
    });
  }, []);

  return (
    <Layout>
      <SeoHead
        title="Thank You | Semper Fi Pump Service"
        description="Thank you for contacting Semper Fi Pump Service. We'll be in touch within 24 hours."
        noindex
      />
      <section className="container py-24 md:py-32 text-center max-w-2xl mx-auto">
        <div className="flex justify-center mb-6">
          <CheckCircle className="w-16 h-16 text-accent" />
        </div>
        <h1 className="text-3xl md:text-4xl font-black mb-4 border-l-0 pl-0">Thank You!</h1>
        <p className="text-lg text-muted-foreground mb-8 text-pretty">
          We've received your service request and will contact you within 24 hours. For faster service, call us directly.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild variant="emergency" size="lg">
            <a href={PHONE_HREF}><Phone className="w-4 h-4" />Call {PHONE_NUMBER}</a>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="/"><ArrowLeft className="w-4 h-4" />Back to Home</Link>
          </Button>
        </div>
      </section>
    </Layout>
  );
};

export default ThankYou;
